export default __webpack_public_path__ + "static/media/empty-filtered-tasks-table.bb10bbef.svg";